<template>
  <v-container fluid class="container">
    <Breadcrumbs
      :items="breadcrumbs"/>

    <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click='excelDownloadClick'>
        Export to Excel
      </v-btn>
    </v-toolbar>

    <ejs-treegrid  id="grid1" ref="grid" :dataSource='items' v-if='dataLoaded' childMapping='sub' :treeColumnIndex='0'
                  :resizeStop="resizeStop" :allowResizing='true' :height='560' :allowExcelExport='true'
                  :excelHeaderQueryCellInfo='excelHeader' :allowFiltering='true' :filterSettings="{type: 'Menu'}">
      <e-columns>
        <e-column field='finrep' :headerText="'Finrep'" :width="columnWidths[0]">
        </e-column>
        <e-column field='summary_pos' :headerText="translate('plannings_plbs_summary_pos')" :width="columnWidths[1]">
        </e-column>
        <e-column field='position' :headerText="translate('plannings_plbs_position')" :width="columnWidths[2]">
        </e-column>
        <e-column textAlign='center' :headerText="translate('Periods')" :columns='periodsColumns'>
        </e-column>
      </e-columns>
    </ejs-treegrid>

    <br>

    <ejs-grid  id="grid2"  ref="gridEco" :dataSource='itemsEco' v-if='dataLoaded' :allowExcelExport='true' :excelHeaderQueryCellInfo='excelHeader'>
      <e-columns>
        <e-column field='title' :headerText="'Title'" width=220>
        </e-column>
        <e-column field='row' :headerText="'Row'" width=220>
        </e-column>
        <e-column field='extra' :headerText="''" width=220>
        </e-column>
        <e-column textAlign='center' :headerText="translate('Periods')" :columns='periodsColumns'>
        </e-column>
      </e-columns>
    </ejs-grid>
    <br>
    <ejs-treegrid id="grid3"  ref="diffap" :dataSource='resultItems' childMapping='sub'
    :treeColumnIndex='0'  :allowExcelExport='true' :excelHeaderQueryCellInfo='excelHeader'>
      <e-columns>
        <e-column field='description' headerText='Description' width='300'></e-column>
        <e-column field='res' headerText=' ' width='220'></e-column>
        <e-column field='dres' headerText=' ' width='220'></e-column>
        <e-column textAlign='center' :columns='columnItems'></e-column>
      </e-columns>
    </ejs-treegrid>
    <Snackbar :text="notificationText"
      :type="notificationType" />
    <v-overlay :value="loader"
      :z-index="1000">
      <v-progress-circular indeterminate
        size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';
import Breadcrumbs from '@/components/Breadcrumbs';
import Snackbar from '@/components/Snackbar';
import {
  TreeGridPlugin, Page, Sort, Resize, Filter, ExcelExport as TreeExcelExport,
} from '@syncfusion/ej2-vue-treegrid';
import {
  GridPlugin, ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import api from '../api/lbt-api';

const {
  getSummaryBSECOFullForPlanning,
} = api;

Vue.use(GridPlugin);
Vue.use(TreeGridPlugin);

export default {
  name: 'SummaryBsEcoFull',
  components: {
    Breadcrumbs,
    Snackbar,
  },
  data() {
    return {
      notificationText: '',
      loader: false,
      dataLoaded: false,
      notificationType: null,
      items: [],
      itemsEco: [],
      expanded: [],
      periods: [],
      resultItems: [],
      columnItems: [],
      storagePrefix: 'bs_eco_full',
      storageSeparator: '.-.',
      columnWidths: [120, 220, 220],
      toolbar: ['ExcelExport', 'PdfExport', 'CsvExport'],
      periodsColumns: [],
      sortOptions: { columns: [{ field: 'tempId', direction: 'Ascending' }, { field: 'id', direction: 'Descending' }] },
      selectionOptions: { mode: 'Cell', type: 'Multiple', cellSelectionMode: 'Box' },
      searchOptions: { fields: ['leasing_type_id'], operator: 'contains', ignoreCase: true },
      pageSettings: { pageSizes: true, pageSize: 100 },
      breadcrumbs: [
        {
          translationKey: 'breadcrumbs_plannings',
          route: '/plannings',
          disabled: false,
        },
        {
          translationKey: 'BS ECO',
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('translations', [
      'translate',
    ]),
    ...mapState('plannings', [
      'activePlanning',
    ]),
  },
  provide: {
    grid: [ExcelExport],
    treegrid: [Page, Sort, Resize, Filter, TreeExcelExport],
  },
  async created() {
    this.headers = [
      {
        text: this.translate('plannings_plbs_summary_pos'),
        align: 'left',
        sortable: false,
        colspan: 10,
      },
      {
        text: this.translate('plannings_plbs_position'),
        align: 'left',
        sortable: false,
        width: 350,
      },
    ];
    this.loader = true;
    this.retrieveColumnWidths();
    try {
      const planning = await getSummaryBSECOFullForPlanning(this.$route.params.planningId);
      this.periods = planning.periods;
      // eslint-disable-next-line arrow-body-style
      this.items = planning.rows;
      this.itemsEco = planning.eco_table;
      this.headers = planning.periods;
      this.prepareHeaders();
      this.updateResultItems();
      this.dataLoaded = true;
    } catch (message) {
      this.notificationText = message;
      this.notificationType = 'error';
      setTimeout(() => { this.notificationText = null; }, 100);
    } finally {
      this.loader = false;
    }
  },
  methods: {
    retrieveColumnWidths() {
      for (let i = 0; i < this.columnWidths.length; i += 1) {
        const width = localStorage.getItem(this.storagePrefix + this.storageSeparator + i);
        if (width) {
          this.columnWidths[i] = width;
        }
      }
    },
    toggleExpandedItem(item) {
      // eslint-disable-next-line
      item.isExpanded = !item.isExpanded;
      this.expanded.push(item);
    },
    customiseCell(queryCellInfo) {
      const { cell } = queryCellInfo;
      if (cell.textContent === 'NaN') {
        cell.classList.add('error');
      }
    },
    excelDownloadClick() {
      const excelExportProperties = {
        multipleExport: { type: 'AppendToSheet', blankRows: 5 },
        fileName: `BS Eco - Planning - ${this.activePlanning.year}-${this.activePlanning.month}.xlsx`,
      };

      // Start exporting the first grid
      this.$refs.grid
        .excelExport(excelExportProperties, true)
        .then(firstExportData => this.$refs.gridEco.excelExport(excelExportProperties, false, firstExportData))
        .then(secondExportData => this.$refs.diffap.excelExport(excelExportProperties, false, secondExportData))
        .catch(() => {
          // console.error('Error during Excel export:', error);
        });
    },
    excelHeader(args) {
      const { cell } = args;
      if (cell.index > 2) {
        cell.value = this.headers[cell.value];
      }
    },
    lookupHeader(idx) {
      return this.periods[Number(idx)];
    },
    resizeStop(item) {
      let width = item.column.width.split('px');
      width = parseInt(width[0], 10);
      localStorage.setItem(this.storagePrefix + this.storageSeparator + item.column.index, width);
    },
    toolbarClick() {
      const grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0];
      grid.excelExport();
    },
    load() {
      const grid = document.getElementsByClassName('e-grid')[0].ej2_instances[0];
      grid.copy(true);
    },
    updateResultItems() {
      const row10 = this.items.length > 14 ? this.items[14].values : [];
      const row5 = this.items.length > 35 ? this.items[35].values : [];
      const differences = row10.map((value, index) => value - (row5[index] || 0));
      if (row10.length && row5.length) {
        // Prepare a single row with each index's difference
        this.resultItems = [{
          description: 'Assets=Liabilities+Equity',
          ...differences.reduce((acc, diff, index) => ({ ...acc, [`diff${index}`]: diff }), {}),
        }];
      }
      this.columnItems = differences.map((_, index) => ({
        field: `diff${index}`,
        headerText: this.headers[Number(index)],
        width: 100,
        textAlign: 'Right',
        format: 'N2',
      }));
    },
    prepareHeaders() {
      const offset = 4;
      const item = this.items[0];
      for (let j = 0; j < item.values.length; j += 1) {
        const width = localStorage.getItem(this.storagePrefix + this.storageSeparator + (offset + j));
        this.periodsColumns.push({
          field: `values.${j}`,
          headerText: j,
          headerValueAccessor: this.lookupHeader,
          width: width != null ? width : 120,
          allowFiltering: false,
          textAlign: 'right',
          format: 'n2',
        });
      }
    },
  },
};
</script>


<style>
  @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-icons/styles/material.css";

  .container {
    padding-bottom: 5rem !important;
  }

  .e-grid.e-default .e-gridheader th.e-firstcell {
    border-left: none;
  }

  .e-dlg-container.e-dlg-center-center,
  .e-dlg-container.e-dlg-center-center {
    display: none;
  }

  .e-grid .e-headercell.highlight-cell, .highlight-cell {
    background: #eeeeee;
  }

  .v-icon.v-icon.delete-action {
    font-size: 16px;
  }
</style>
